var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconVideo = function SvgIconVideo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 69.8 88.7"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0A070C",
    d: "M0 88.7V0l69.8 44.3L0 88.7zm7-74.5v60.4l47.6-30.2L7 14.2z"
  })));
};
export default SvgIconVideo;